import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PaginationButton } from './PaginationButton-DMbVKhZU.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const PaginationNextButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-next-button'),
  icon: angleInlineEnd
}, props));
PaginationNextButton.displayName = 'PaginationNextButton';

export { PaginationNextButton as P };
//# sourceMappingURL=PaginationNextButton-DqSiwRCb.js.map
